// components/LanguageSwitcher.js
import { useEffect } from "react";

function LanguageSwitcher() {
  useEffect(() => {
    // Set the gtranslate settings globally
    window.gtranslateSettings = {
      default_language: "en",
      languages: ["en", "fr", "de", "it", "es", "ar", "ru", "id"],
      wrapper_selector: ".gtranslate_wrapper",
    };

    // Dynamically load the script AFTER the div is rendered
    const script = document.createElement("script");
    script.src = "https://cdn.gtranslate.net/widgets/latest/dropdown.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div className="gtranslate_wrapper lan_dropdown" />;
}

export default LanguageSwitcher;
